import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import "../styles/stats.css";
import { 
  Users, 
  Globe, 
  Award, 
  Clock,
  ThumbsUp,
  TrendingUp
} from "lucide-react";

export default function StatsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  
  const stats = [
    { icon: <Globe />, value: "150+", label: "Projets Livrés", suffix: "" },
    { icon: <Users />, value: "98", label: "Clients Satisfaits", suffix: "%" },
    { icon: <Award />, value: "5", label: "Ans d'Expérience", suffix: "+" },
    { icon: <Clock />, value: "24/7", label: "Support", suffix: "" },
    { icon: <ThumbsUp />, value: "4.9", label: "Note Clients", suffix: "/5" },
    { icon: <TrendingUp />, value: "300", label: "Trafic Augmenté", suffix: "%" }
  ];

  return (
    <section className="stats-section" ref={ref}>
      <div className="container">
        <div className="stats-background">
          <div className="stats-gradient"></div>
        </div>
        
        <div className="section-header">
          <h2 className="section-title">Chiffres qui Parlent</h2>
          <p className="section-subtitle">
            Notre impact et notre engagement en quelques chiffres
          </p>
        </div>
        
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <motion.div 
              key={index}
              className="stat-card"
              initial={{ opacity: 0, scale: 0.5 }}
              animate={isInView ? { opacity: 1, scale: 1 } : {}}
              transition={{ delay: index * 0.1, duration: 0.5 }}
            >
              <div className="stat-icon">
                {stat.icon}
              </div>
              <div className="stat-content">
                <h3 className="stat-value">
                  {isInView ? stat.value : "0"}
                  <span className="stat-suffix">{stat.suffix}</span>
                </h3>
                <p className="stat-label">{stat.label}</p>
              </div>
            </motion.div>
          ))}
        </div>
        
        <div className="stats-achievements">
          <motion.div 
            className="achievement"
            initial={{ opacity: 0, x: -20 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ delay: 0.6 }}
          >
            <div className="achievement-icon">🏆</div>
            <div className="achievement-content">
              <h4>Expertise Certifiée</h4>
              <p>Partenaires Google, Facebook et Shopify</p>
            </div>
          </motion.div>
          
          <motion.div 
            className="achievement"
            initial={{ opacity: 0, x: 20 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ delay: 0.8 }}
          >
            <div className="achievement-icon">🚀</div>
            <div className="achievement-content">
              <h4>Innovation Continue</h4>
              <p>Veille technologique et formations régulières</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}